import React, { useState } from "react";
import styles from "./CustomTextInput.module.css";

const CustomTextInput = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled = false,
  required = false,
  readOnly = false,
  error,
  helperText,
  maxLength,
  minLength,
  autoComplete = "off",
  className = "",
  inputClassName = "",
  labelClassName = "",
  size = "md",
  icon,
  iconPosition = "left",
  onIconClick,
  multiline = false, // ✅ ADD
  rows = 4,
  actionLabel,
  onActionClick,
  actionLoading = false,
  actionDisabled = false,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const inputType = type === "password" && showPassword ? "text" : type;
  const hasAction = Boolean(actionLabel);

  return (
    <div className={`${styles.inputWrapper} ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className={`${styles.label} ${labelClassName} ${
            disabled ? styles.labelDisabled : ""
          }`}
        >
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}

      <div
        className={`${styles.inputContainer} ${styles[size]} ${
          hasAction ? styles.inputContainerWithAction : ""
        }`}
      >
        {/* Left Icon */}
        {icon && iconPosition === "left" && (
          <span
            className={`${styles.icon} ${styles.iconLeft}`}
            onClick={onIconClick}
          >
            {icon}
          </span>
        )}

        {multiline ? (
          <textarea
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            maxLength={maxLength}
            minLength={minLength}
            rows={rows}
            className={`
      ${styles.textarea}
      ${inputClassName}
      ${error ? styles.inputError : ""}
      ${disabled ? styles.inputDisabled : ""}
      ${hasAction ? styles.inputWithAction : ""}
    `}
            aria-invalid={!!error}
            aria-describedby={
              error || helperText ? `${name}-helper` : undefined
            }
            {...rest}
          />
        ) : (
          <input
            type={inputType}
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            maxLength={maxLength}
            minLength={minLength}
            autoComplete={autoComplete}
            className={`
      ${styles.input}
      ${inputClassName}
      ${error ? styles.inputError : ""}
      ${disabled ? styles.inputDisabled : ""}
      ${icon && iconPosition === "left" ? styles.inputWithLeftIcon : ""}
      ${
        (icon && iconPosition === "right") || type === "password"
          ? styles.inputWithRightIcon
          : ""
      }
      ${hasAction ? styles.inputWithAction : ""}
    `}
            aria-invalid={!!error}
            aria-describedby={
              error || helperText ? `${name}-helper` : undefined
            }
            {...rest}
          />
        )}

        {/* Right Icon (Not password) */}
        {icon && iconPosition === "right" && type !== "password" && (
          <span
            className={`${styles.icon} ${styles.iconRight}`}
            onClick={onIconClick}
          >
            {icon}
          </span>
        )}

        {type === "password" && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className={styles.passwordToggle}
            disabled={disabled}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <i
              className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
            />
          </button>
        )}

        {hasAction && (
          <button
            type="button"
            className={styles.actionButton}
            onClick={onActionClick}
            disabled={actionDisabled || actionLoading}
          >
            {actionLoading ? (
              <span className={styles.actionSpinner} />
            ) : (
              actionLabel
            )}
          </button>
        )}
      </div>

      {(error || helperText) && (
        <span
          id={`${name}-helper`}
          className={`${styles.helperText} ${error ? styles.errorText : ""}`}
        >
          {error || helperText}
        </span>
      )}
    </div>
  );
};

export default CustomTextInput;
